import apiWrapper from 'Helpers/apiWrapper'

const endpoints = ((baseURL) => {
  return {
    taskTracking: (idTask) =>
      `${baseURL}/api/task/${encodeURIComponent(idTask)}`,
  }
})(process.env.BEASYNCTASKS_URL)

/**
 * @description Get details of a task given the Id
 * @param {number} idTask The id of the task
 * @returns {string} Type
 * @returns {string} Status
 * @returns {string} Metadata
 * @returns {number} TotalStep
 * @returns {number} Step
 * @returns {number} Id
 * @returns {number} IdList
 * @returns {string} CreationDate ISO String Date
 * @returns {string} UpdateDate ISO String Date
 **/

export const beAsyncTaskGetTaskDetails = (idTask) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.taskTracking(idTask),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(({ data }) => data)
}

export const beAsyncTaskUpdateAsyncTask = (idTask, data) => {
  return apiWrapper({
    method: 'put',
    url: endpoints.taskTracking(idTask),
    headers: {
      'Content-Type': 'application/json',
    },
    data: JSON.stringify(data),
  }).then(({ data }) => data)
}
